// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.signup-page-container {
  height: 100vh;
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  justify-content: center;
  font-family: "Source Sans Pro", sans-serif;
  color: #373F50;
}
.signup-page-container .signup-logo {
  position: absolute;
  top: 30px;
  left: 30px;
  width: 289px;
}
.signup-page-container .button-text, .signup-page-container .button-no-text {
  width: 100%;
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
  margin-top: 30px;
}
.signup-page-container .button-no-text {
  justify-content: flex-end;
}
.signup-page-container .signup-button {
  font-family: "Source Sans Pro", sans-serif;
  color: #FFFFFF;
  font-weight: 600;
  font-size: 20px;
  line-height: 25px;
  background-color: #008CCE;
  padding: 12px 33px;
  border: none;
  border-radius: 3px;
  min-width: 105px;
}
.signup-page-container .signup-button .MuiCircularProgress-root {
  color: white;
  max-width: 20px;
  max-height: 20px;
}
.signup-page-container .entered-keyword {
  font-weight: 600;
  font-size: 14px;
  line-height: 18px;
  font-style: italic;
}
.signup-page-container .name-inputs-container {
  width: 100%;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: space-between;
}
.signup-page-container .mb-31 {
  margin-bottom: 31px;
}
.signup-page-container .comp-input-label {
  margin-bottom: 20px;
}
.signup-page-container .comp-input-label .competitor-label {
  font-size: 11px;
  line-height: 14px;
  margin-left: 18px;
}
.signup-page-container .error-label {
  font-size: 12px;
  line-height: 15px;
  letter-spacing: 0.0125em;
  color: #B00020;
  margin-left: 18px;
}
.signup-page-container .keyword-entered {
  font-weight: 600;
  font-size: 14px;
  line-height: 18px;
  margin-top: 19px;
  align-self: flex-start;
}
.signup-page-container .password-req-text {
  font-size: 11px;
  line-height: 14px;
  letter-spacing: 0.0125em;
  color: #373F50;
  margin-left: 16px;
  margin-right: 8px;
}
.signup-page-container .password-req-text.password-error {
  color: #B00020;
  font-weight: bold;
}
.signup-page-container .step-container {
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  justify-content: center;
  max-width: 402px;
}
.signup-page-container .step-container .phrase-label {
  font-size: 12px;
  line-height: 15px;
  margin: 2px 0px 36px 17px;
}
.signup-page-container .step-container .checkbox-label-container {
  align-self: flex-start;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 30px;
}
.signup-page-container .step-container .checkbox-label-container .tc-check {
  width: 24px;
  height: 24px;
  border: 1px solid #373F50;
  border-radius: 2px;
  margin-right: 9px;
  accent-color: #008CCE;
}
.signup-page-container .step-container .checkbox-label-container .tc-label {
  font-size: 12px;
  line-height: 15px;
  letter-spacing: 0.004em;
}
.signup-page-container .step-container .sign-in-text {
  font-size: 16px;
  line-height: 20px;
}
.signup-page-container .step-container .sign-in-text a {
  color: #008CCE;
}
.signup-page-container .su-header {
  font-size: 30px;
  line-height: 38px;
}
.signup-page-container .su-sub-header {
  font-size: 24px;
  line-height: 30px;
  margin-bottom: 8px;
}
.signup-page-container .help-text {
  font-size: 16px;
  line-height: 20px;
  text-align: center;
  letter-spacing: 0.0125em;
  margin-bottom: 20px;
}
.signup-page-container .su-form {
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
}
.signup-page-container .su-form .phrase-label {
  align-self: flex-start;
}

.dj-red {
  color: #B00020;
}`, "",{"version":3,"sources":["webpack://./src/components/signup/signup.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,aAAA;EACA,wBAAA;EACA,mBAAA;EACA,uBAAA;EACA,0CAAA;EACE,cAAA;AACJ;AACE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,YAAA;AACJ;AAEE;EACE,WAAA;EACA,aAAA;EACA,qBAAA;EACA,8BAAA;EACA,mBAAA;EACA,gBAAA;AAAJ;AAEE;EACE,yBAAA;AAAJ;AAEE;EACE,0CAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;AAAJ;AACI;EACE,YAAA;EACA,eAAA;EACA,gBAAA;AACN;AAEE;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;AAAJ;AAEE;EACE,WAAA;EAEA,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,8BAAA;AADJ;AAGE;EACE,mBAAA;AADJ;AAGE;EACE,mBAAA;AADJ;AAEI;EACE,eAAA;EACA,iBAAA;EACA,iBAAA;AAAN;AAGE;EACE,eAAA;EACA,iBAAA;EACA,wBAAA;EACA,cAAA;EACA,iBAAA;AADJ;AAGE;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,sBAAA;AADJ;AAGE;EACE,eAAA;EACA,iBAAA;EACA,wBAAA;EACA,cAAA;EACA,iBAAA;EACA,iBAAA;AADJ;AAEI;EACE,cAAA;EACA,iBAAA;AAAN;AAIE;EACE,aAAA;EACA,wBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;AAFJ;AAGI;EACE,eAAA;EACA,iBAAA;EACA,yBAAA;AADN;AAGI;EACE,sBAAA;EACA,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,2BAAA;EACA,mBAAA;AADN;AAEM;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,qBAAA;AAAR;AAEM;EACE,eAAA;EACA,iBAAA;EACA,uBAAA;AAAR;AAGI;EACE,eAAA;EACA,iBAAA;AADN;AAEM;EACE,cAAA;AAAR;AAKE;EACE,eAAA;EACA,iBAAA;AAHJ;AAKE;EACE,eAAA;EACA,iBAAA;EACA,kBAAA;AAHJ;AAKE;EACE,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,wBAAA;EACA,mBAAA;AAHJ;AAKE;EACE,aAAA;EACA,wBAAA;EACA,mBAAA;AAHJ;AAII;EACE,sBAAA;AAFN;;AAMA;EACE,cAAA;AAHF","sourcesContent":[".signup-page-container{\n  height: 100vh;\n  display: flex;\n  flex-flow: column nowrap;\n  align-items: center;\n  justify-content: center;\n  font-family: \"Source Sans Pro\", sans-serif;\n    color: #373F50;\n\n  .signup-logo{\n    position: absolute;\n    top: 30px;\n    left: 30px;\n    width: 289px;\n\n  }\n  .button-text, .button-no-text {\n    width: 100%;\n    display: flex;\n    flex-flow: row nowrap;\n    justify-content: space-between;\n    align-items: center;\n    margin-top: 30px;\n  }\n  .button-no-text{\n    justify-content: flex-end;\n  }\n  .signup-button {\n    font-family: \"Source Sans Pro\", sans-serif;\n    color: #FFFFFF;\n    font-weight: 600;\n    font-size: 20px;\n    line-height: 25px;\n    background-color: #008CCE;\n    padding: 12px 33px;\n    border: none;\n    border-radius: 3px;\n    min-width: 105px;\n    .MuiCircularProgress-root{\n      color: white;\n      max-width: 20px;\n      max-height: 20px;\n    }\n  }\n  .entered-keyword {\n    font-weight: 600;\n    font-size: 14px;\n    line-height: 18px;\n    font-style: italic;\n  }\n  .name-inputs-container{\n    width: 100%;\n\n    display: flex;\n    flex-flow: row nowrap;\n    align-items: center;\n    justify-content: space-between;\n  }\n  .mb-31{\n    margin-bottom: 31px;\n  }\n  .comp-input-label{\n    margin-bottom: 20px;\n    .competitor-label{\n      font-size: 11px;\n      line-height: 14px;\n      margin-left: 18px;\n    }\n  }\n  .error-label{\n    font-size: 12px;\n    line-height: 15px;\n    letter-spacing: 0.0125em;\n    color: #B00020;\n    margin-left: 18px;\n  }\n  .keyword-entered{\n    font-weight: 600;\n    font-size: 14px;\n    line-height: 18px;\n    margin-top: 19px;\n    align-self: flex-start;\n  }\n  .password-req-text{\n    font-size: 11px;\n    line-height: 14px;\n    letter-spacing: 0.0125em;\n    color: #373F50;\n    margin-left: 16px;\n    margin-right: 8px;\n    &.password-error {\n      color: #B00020;\n      font-weight: bold;\n    }\n  }\n\n  .step-container {\n    display: flex;\n    flex-flow: column nowrap;\n    align-items: center;\n    justify-content: center;\n    max-width: 402px;\n    .phrase-label {\n      font-size: 12px;\n      line-height: 15px;\n      margin: 2px 0px 36px 17px;\n    }\n    .checkbox-label-container {\n      align-self: flex-start;\n      display: flex;\n      flex-flow: row nowrap;\n      align-items: center;\n      justify-content: flex-start;\n      margin-bottom: 30px;\n      .tc-check {\n        width: 24px;\n        height: 24px;\n        border: 1px solid #373F50;\n        border-radius: 2px;\n        margin-right: 9px;\n        accent-color: #008CCE;\n      }\n      .tc-label {\n        font-size: 12px;\n        line-height: 15px;\n        letter-spacing: 0.004em;\n      }\n    }\n    .sign-in-text{\n      font-size: 16px;\n      line-height: 20px;\n      a{\n        color: #008CCE;\n      }\n    }\n\n  }\n  .su-header{\n    font-size: 30px;\n    line-height: 38px;\n  }\n  .su-sub-header {\n    font-size: 24px;\n    line-height: 30px;\n    margin-bottom: 8px;\n  }\n  .help-text {\n    font-size: 16px;\n    line-height: 20px;\n    text-align: center;\n    letter-spacing: 0.0125em;\n    margin-bottom: 20px;\n  }\n  .su-form {\n    display: flex;\n    flex-flow: column nowrap;\n    align-items: center;\n    .phrase-label {\n      align-self: flex-start;\n    }\n  }\n}\n.dj-red{\n  color: #B00020;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
